import { Box } from '@bechtel/gds';
import { map } from 'lodash';
import { FC } from 'react';
import { MetadataText, MultiLingualText, UserInfo, useTableMetadataContext } from '~/components';
import { ContainerStyled } from './styled';
import { CommoditySignatureProps, SignatureItemProps } from './types';

const SignatureItem: FC<SignatureItemProps> = (props) => {
  const tableMetadata = useTableMetadataContext();
  return (
    <Box px={{ sm: '400' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-between' }}>
      <Box style={{ width: '37%' }}>
        {tableMetadata && (
          <MetadataText metadataTable={tableMetadata} size="300" color="grey.800" memberName={props.memberName} />
        )}
      </Box>
      <Box
        css={{ width: '63%' }}
        justifyContent={{ sm: 'flex-start' }}
        ml={{ sm: '400' }}
        style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}
      >
        <UserInfo {...props} />
      </Box>
    </Box>
  );
};

export const Signature: FC<CommoditySignatureProps> = ({ signatureData }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} pt={{ sm: '450' }}>
      <Box
        pb={{ sm: '400' }}
        css={`
          ${({ theme }) => `border-bottom: 1px solid ${theme.colors.primary[900]};`}
        `}
      >
        <MultiLingualText size="400" weight="600" color="primary.900">
          Signatures
        </MultiLingualText>
      </Box>
      <ContainerStyled>
        {map(signatureData, (item, index) => {
          return <SignatureItem key={index} {...item} />;
        })}
      </ContainerStyled>
    </Box>
  );
};
